<template>
  <a-layout>
    <Breadcrumb>
      <BreadcrumbItem> 查看 </BreadcrumbItem>
    </Breadcrumb>
    <div class="page-title-container">
      <span class="page-title">前期手续 - {{ sectionThree.projectName }}</span>
    </div>
    <div class="content-container">
      <div class="container">
        <div class="steps-content">

          <div class="field-container">
            <div class="field-label optional-field-container">
              <span class="field-label optional-field field-label__bold">备案证</span>
            </div>
            <div class="field-content">
              <p v-for="doc in registration.docList" :key="doc.uid">
                <a v-if="showDownload" @click="download(doc)" class="download-btn"><a-icon type="download" /> 下载 </a>
                <a @click="preview(doc)"><a-icon type="eye" /> {{ doc.name }}</a>
              </p>
              <span v-if="registration.docList.length ===0">暂无</span>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label optional-field-container">
              <span class="field-label optional-field field-label__bold">电网消纳意见</span>
            </div>
            <div class="field-content">
              <p v-for="doc in gridIngestion.docList" :key="doc.uid">
                <a v-if="showDownload" @click="download(doc)" class="download-btn"><a-icon type="download" /> 下载 </a>
                <a @click="preview(doc)"><a-icon type="eye" /> {{ doc.name }}</a>
              </p>
              <span v-if="gridIngestion.docList.length ===0">暂无</span>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label optional-field-container">
              <span class="field-label optional-field field-label__bold">荷载报告</span>
            </div>
            <div class="field-content">
              <p v-for="doc in loadReport.docList" :key="doc.uid">
                <a v-if="showDownload" @click="download(doc)" class="download-btn"><a-icon type="download" /> 下载 </a>
                <a @click="preview(doc)"><a-icon type="eye" /> {{ doc.name }}</a>
              </p>
              <span v-if="loadReport.docList.length ===0">暂无</span>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label optional-field-container">
              <span class="field-label optional-field field-label__bold">初设方案</span>
            </div>
            <div class="field-content">
              <p v-for="doc in initialDesign.docList" :key="doc.uid">
                <a v-if="showDownload" @click="download(doc)" class="download-btn"><a-icon type="download" /> 下载 </a>
                <a @click="preview(doc)"><a-icon type="eye" /> {{ doc.name }}</a>
              </p>
              <span v-if="initialDesign.docList.length ===0">暂无</span>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label optional-field-container">
              <span class="field-label optional-field field-label__bold">环保部门意见（环评登记表）</span>
            </div>
            <div class="field-content">
              <p v-for="doc in envReview.docList" :key="doc.uid">
                <a v-if="showDownload" @click="download(doc)" class="download-btn"><a-icon type="download" /> 下载 </a>
                <a @click="preview(doc)"><a-icon type="eye" /> {{ doc.name }}</a>
              </p>
              <span v-if="envReview.docList.length ===0">暂无</span>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label optional-field-container">
              <span class="field-label optional-field field-label__bold">电力接入系统方案</span>
            </div>
            <div class="field-content">
              <p v-for="doc in powerConnection.docList" :key="doc.uid">
                <a v-if="showDownload" @click="download(doc)" class="download-btn"><a-icon type="download" /> 下载 </a>
                <a @click="preview(doc)"><a-icon type="eye" /> {{ doc.name }}</a>
              </p>
              <span v-if="powerConnection.docList.length ===0">暂无</span>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label optional-field-container">
              <span class="field-label optional-field field-label__bold">电网接入系统方案批复</span>
            </div>
            <div class="field-content">
              <p v-for="doc in powerConnectionReply.docList" :key="doc.uid">
                <a v-if="showDownload" @click="download(doc)" class="download-btn"><a-icon type="download" /> 下载 </a>
                <a @click="preview(doc)"><a-icon type="eye" /> {{ doc.name }}</a>
              </p>
              <span v-if="powerConnectionReply.docList.length ===0">暂无</span>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label optional-field-container">
              <span class="field-label optional-field field-label__bold">社稳意见（若涉及需提供）</span>
            </div>
            <div class="field-content">
              <p v-for="doc in socialStable.docList" :key="doc.uid">
                <a v-if="showDownload" @click="download(doc)" class="download-btn"><a-icon type="download" /> 下载 </a>
                <a @click="preview(doc)"><a-icon type="eye" /> {{ doc.name }}</a>
              </p>
              <span v-if="socialStable.docList.length ===0">暂无</span>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label optional-field-container">
              <span class="field-label optional-field field-label__bold">技术可行性</span>
            </div>
            <div class="field-content">
              <p v-for="doc in techFeasible.docList" :key="doc.uid">
                <a v-if="showDownload" @click="download(doc)" class="download-btn"><a-icon type="download" /> 下载 </a>
                <a @click="preview(doc)"><a-icon type="eye" /> {{ doc.name }}</a>
              </p>
              <span v-if="techFeasible.docList.length ===0">暂无</span>
            </div>
          </div>

          <div class="field-container">
            <div class="field-label optional-field-container">
              <span class="field-label optional-field field-label__bold">其他资料</span>
            </div>
            <div class="field-content">
              <p v-for="doc in otherAttachment.docList" :key="doc.uid">
                <a v-if="showDownload" @click="download(doc)" class="download-btn"><a-icon type="download" /> 下载 </a>
                <a @click="preview(doc)"><a-icon type="eye" /> {{ doc.name }}</a>
              </p>
              <span v-if="otherAttachment.docList.length ===0">暂无</span>
            </div>
          </div>

        </div>
      </div>
    </div>

    <DocPreview ref="docPreview" />
  </a-layout>
</template>
<script>
import {loadSectionThree, saveAdditionalDocs} from "@/services/SpecService";
import {baseURL} from "@/services/HttpService";
import Breadcrumb from "@/components/Breadcrumb.vue";
import BreadcrumbItem from "@/components/BreadcrumbItem.vue";
import DocPreview from "@/views/DocPreview.vue";
import {changeToAbsImgPath} from "@/utils/absUrl";

export default {
  components: {BreadcrumbItem, Breadcrumb, DocPreview},
  props: {
    projectId: String,
    mode: String,
    showDownload: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      viewUrl: baseURL + "/attachment?fileName=",
      uploadUrl: baseURL + "/upload/spec",
      sectionThree: {
        companyId:"",
        technicalFeasibility:"",
        costFeasibility:"",
        loanFeasibility: "",
        invoiceRatio: "",
        advanceFunding: "",
        roi:"",
        projectName:"",
        isEditable: false
      },
      registration:{
        loading: false,
        docList: [],
        title: ""
      },
      landUsageOpinion: {
        loading: false,
        docList: [],
        title: "用地意见"
      },
      envReview: {
        loading: false,
        docList: [],
        title: "环评登记表"
      },
      socialStable: {
        loading: false,
        docList: [],
        title: "社稳意见"
      },
      loadReport: {
        loading: false,
        docList: [],
        title: ""
      },
      initialDesign: {
        loading: false,
        docList: [],
        title: ""
      },
      gridIngestion: {
        loading: false,
        docList: [],
        title: ""
      },
      powerConnection: {
        loading: false,
        docList: [],
        title: ""
      },
      powerConnectionReply: {
        loading: false,
        docList: [],
        title: ""
      },
      techFeasible: {
        loading: false,
        docList: [],
        title: "技术可行性"
      },
      otherAttachment: {
        loading: false,
        docList: [],
        title: "其他资料"
      },
    }
  },
  mounted() {
    this.startLoadSectionThree();
  },
  methods: {
    getCompanyId() {
      return this.sectionThree.companyId;
    },
    startLoadSectionThree(){
      if(this.projectId && this.projectId!=="" && this.projectId !== "0") {
        loadSectionThree(this.projectId).then(resp => {
          if (resp.data.code === "SUCCESS") {
            let data = resp.data.data;
            console.log('s3', data);
            this.sectionThree = data;

            this.buildDocList(data.loadReportDocList, 'loadReport');
            this.buildDocList(data.initialDesignDocList, 'initialDesign');
            this.buildDocList(data.gridIngestionDocList, 'gridIngestion');
            this.buildDocList(data.powerConnectionDocList, 'powerConnection');
            this.buildDocList(data.powerConnectionReplyDocList, 'powerConnectionReply');

            this.buildDocList(data.registrationDocList, 'registration');
            this.buildDocList(data.landUsageOpinionDocList, 'landUsageOpinion');
            this.buildDocList(data.envReviewDocList, 'envReview');
            this.buildDocList(data.socialStableDocList, 'socialStable');
            this.buildDocList(data.techFeasibleDocList, 'techFeasible');
            this.buildDocList(data.otherAttachmentDocList, 'otherAttachment');
          }
        });
      }
    },
    buildDocList(docList, propName) {
      if(docList && docList.length > 0) {
        for (let i = 0; i < docList.length; i++) {
          let doc = docList[i];
          this[propName].docList.push({
            uid: doc.uid,
            name: doc.name,
            status: 'done',
            url: this.viewUrl + doc.url
          });
        }
      }
    },
    preview(doc) {
      this.$refs.docPreview.previewFile(doc);
    },
    onLoadReportUpload(info){
      let fileList = changeToAbsImgPath(info);
      this.loadReport.docList = fileList;
      if(info.file.status==='done' || info.file.status==='removed'){
        this.saveDoc(fileList, '荷载报告');
      }
    },
    onGridIngestionUpload(info){
      let fileList = changeToAbsImgPath(info);
      this.gridIngestion.docList = fileList;
      if(info.file.status==='done' || info.file.status==='removed'){
        this.saveDoc(fileList, '电网消纳意见');
      }
    },
    onPowerConnectionUpload(info) {
      let fileList = changeToAbsImgPath(info);
      this.powerConnection.docList = fileList;
      if(info.file.status==='done' || info.file.status==='removed'){
        this.saveDoc(fileList, '电力接入系统方案');
      }
    },
    onPowerConnectionReplyUpload(info) {
      let fileList = changeToAbsImgPath(info);
      this.powerConnectionReply.docList = fileList;
      if(info.file.status==='done' || info.file.status==='removed'){
        this.saveDoc(fileList, '电网接入系统方案批复');
      }
    },
    saveDoc(fileList, typeName){
      let params = {
        projectId: this.projectId,
        type: typeName,
        fileList: []
      }
      if(typeName==="荷载报告") {
        this.prepareDocList(this.loadReport.docList, params, "fileList");
      } else if (typeName==="电网消纳意见") {
        this.prepareDocList(this.gridIngestion.docList, params, "fileList");
      } else if (typeName==="电力接入系统方案") {
        this.prepareDocList(this.powerConnection.docList, params, "fileList");
      } else if (typeName==="电网接入系统方案批复") {
        this.prepareDocList(this.powerConnectionReply.docList, params, "fileList");
      }
      saveAdditionalDocs(params).then(resp => {
        if(resp.data.code !== "SUCCESS") {
          this.$message.error("保存文件失败");
        }
      });
    },
    prepareDocList(docList, params, propName){
      if(docList.length > 0) {
        for (let i = 0;i< docList.length; i++) {
          let oneDoc = docList[i];
          params[propName].push({
            uid: oneDoc.uid,
            name: oneDoc.name,
            url: oneDoc.url.replace(this.viewUrl, '')
          });
        }
      }
    },
    download(doc){
      window.open(doc.url, '_blank');
    },

  }
}
</script>
<style scoped>
.download-btn {
  margin-right: 30px;
}
</style>